import React from "react";
import { sortBy } from "lodash";
import { db } from "../services/firebase";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField, renderSelect } from "./_fieldRenderer";

import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.product) {
    errors.product = "Obrigatório";
  }
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  if (!values.details) {
    errors.details = "Obrigatório";
  }
  if (!values.tables) {
    errors.tables = "Obrigatório";
  }
  if (!values.status) {
    errors.status = "Obrigatório";
  }
  return errors;
};

class IndicatorForm extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;
    this.state = {
      products: [],
      tables: [],
      fetchingTables: false,
      fetchingProducts: false,
      statusIndicator: [
        {
          label: "Ativado",
          value: 1,
        },
        {
          label: "Desativado",
          value: 0,
        },
      ],
    };
  }

  componentDidMount() {
    const products = [];
    this.setState({ fetchingProducts: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("products")
      .get()
      .then((productSnapshot) => {
        if (!productSnapshot.empty) {
          productSnapshot.forEach((product) =>
            products.push({
              value: product.id,
              label: `${product.data().name}`,
            })
          );
          this.setState({ fetchingProducts: false, products });
        } else {
          this.setState({ fetchingProducts: false, products });
        }
      });
    const tables = [];
    this.setState({ fetchingTables: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("tables")
      .get()
      .then((tableSnapshot) => {
        if (!tableSnapshot.empty) {
          tableSnapshot.forEach((table) =>
            tables.push({
              value: table.id,
              label: `${table.data().name}`,
            })
          );
          this.setState({ fetchingTables: false, tables });
        } else {
          this.setState({ fetchingTables: false, tables });
        }
      });
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Field
                name="product"
                component={renderSelect}
                label="Produto"
                disabled={!this.state.products.length}
                placeholder={this._handlePlaceholder(this.state.products)(
                  this.state.fetchingProducts
                )("male")}
                options={sortBy(this.state.products, ["label", "asc"])}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Field
                name="tables"
                component={renderSelect}
                label="Mesa"
                disabled={!this.state.tables.length}
                placeholder={this._handlePlaceholder(this.state.tables)(
                  this.state.fetchingTables
                )("male")}
                options={sortBy(this.state.tables, ["label", "asc"])}
              />
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup>
              <Field
                name="details"
                type="text"
                component={renderField}
                label="Instruções de coleta"
                placeholder="Instruções de coleta"
              />
            </FormGroup>
          </Col>

          <Col md={12}>
            <FormGroup>
              <Field
                name="status"
                component={renderSelect}
                label="Status"
                placeholder="Selecione o status do Indicador"
                options={sortBy(this.state.statusIndicator, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };

  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}

IndicatorForm = reduxForm({ form: "IndicatorForm", validate })(IndicatorForm);
export default IndicatorForm;



// WEBPACK FOOTER //
// ./src/forms/IndicatorForm.jsx